export const getThumbnailUrl = (videoId: string) => {
  return `https://cloudflarestream.com/${videoId}/thumbnails/thumbnail.jpg`;
};
